import EventExperiences from "./index.vue";
import Vue from "vue";
import {
  ContainerMethods,
  ContainerData,
  ContainerComputed,
  ContainerProps
} from "./types";
import {
  EventPurpose,
  EventCategory,
  EventCategoryNames,
  EventPurposeNames,
  BME_PART
} from "@/api/types";

export default Vue.extend<
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
>({
  data() {
    return {
      isFetchingEventExperiences: false
    };
  },
  computed: {
    hasEventExperienceQueries() {
      const isInValidated = [
        this.companyId,
        this.graduateYear,
        this.eventPurpose,
        this.startAt,
        this.endAt
      ].some(query => !query);
      return !isInValidated;
    },
    companyId() {
      const { cid } = this.$route.query;
      if (typeof cid !== "string") return;
      return Number(cid);
    },
    graduateYear() {
      const { gy } = this.$route.query;
      if (typeof gy !== "string") return;
      return Number(gy);
    },
    eventPurpose() {
      const { p } = this.$route.query;
      const isValid =
        typeof p === "string" &&
        Object.values(EventPurpose).includes(p as EventPurpose);
      return isValid ? (p as EventPurpose) : undefined;
    },
    eventCategory() {
      const { c } = this.$route.query;
      const isValid =
        typeof c === "string" &&
        Object.values(EventCategory).includes(c as EventCategory);
      return isValid ? (c as EventCategory) : undefined;
    },
    startAt() {
      const { s } = this.$route.query;
      const isValid = typeof s === "string" && s.length === 10;
      return isValid ? this.createBMEPeriod(s as string) : undefined;
    },
    endAt() {
      const { e } = this.$route.query;
      if (typeof e !== "string") return;
      const isValid = typeof e === "string" && e.length === 10;
      return isValid ? this.createBMEPeriod(e as string) : undefined;
    },
    eventExperiences() {
      const domainEventExperiences = this.$store.state.domains.eventExperiences;
      return domainEventExperiences.eventExperiences;
    },
    headerTitle() {
      if (this.eventCategory && this.eventPurpose) {
        return `${EventCategoryNames[this.eventCategory]}(${
          EventPurposeNames[this.eventPurpose]
        })`;
      } else if (this.eventPurpose) {
        return `${EventPurposeNames[this.eventPurpose]}`;
      }
      return "";
    },
    clips() {
      return this.$store.state.domains.clips.clips;
    }
  },

  mounted() {
    if (!this.hasEventExperienceQueries) {
      this.$router.push({ name: "Error" }).catch(err => err);
    } else {
      this.fetchEventExperiences();
    }
  },
  methods: {
    async fetchEventExperiences(loading = true) {
      try {
        this.isFetchingEventExperiences = loading;
        await this.$store.dispatch(
          "domains/eventExperiences/getEventExperiences",
          {
            company_id: this.companyId!,
            graduate_year: this.graduateYear!,
            purpose: this.eventPurpose!,
            category: this.eventCategory,
            start_at: this.startAt!,
            end_at: this.endAt!
          }
        );
      } catch (error) {
        throw error;
      } finally {
        this.isFetchingEventExperiences = false;
      }
    },
    async createClip(params) {
      try {
        await this.$store.dispatch("domains/clips/createClip", {
          event_detail_id: params.event_detail_id,
          experience_id: params.experience_id
        });
      } catch (error) {
        throw error;
      }
    },
    async deleteClip(params) {
      try {
        await this.$store.dispatch("domains/clips/deleteClip", {
          clip_id: params.clip_id
        });
      } catch (error) {
        throw error;
      }
    },
    createBMEPeriod(formattedBMEPeriod) {
      const type = formattedBMEPeriod.slice(0, 1);
      const part = formattedBMEPeriod.slice(1, 2);
      const year = formattedBMEPeriod.slice(2, 6);
      const month = formattedBMEPeriod.slice(6, 8);
      const day = formattedBMEPeriod.slice(8, 10);

      return {
        type: type === "1" ? "BME" : "DATE_RANGE",
        part: Number(part) as BME_PART,
        year: Number(year),
        month: Number(month),
        day: day === "00" ? null : Number(day)
      };
    }
  },
  render(createElement) {
    return createElement(EventExperiences, {
      props: {
        eventExperiences:
          this.eventExperiences && this.eventExperiences.event_experiences,
        company:
          this.eventExperiences && this.eventExperiences.competitor.company,
        graduateYear:
          this.eventExperiences &&
          Number(this.eventExperiences.graduate_year.substring(0, 4)),
        headerTitle: this.headerTitle,
        isLoading: this.isFetchingEventExperiences
      },
      on: {
        createClip: this.createClip,
        deleteClip: this.deleteClip
      }
    });
  }
});
